import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=895970dc&scoped=true"
import script from "./projectList.vue?vue&type=script&lang=js"
export * from "./projectList.vue?vue&type=script&lang=js"
import style0 from "./projectList.vue?vue&type=style&index=0&id=895970dc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895970dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('895970dc')) {
      api.createRecord('895970dc', component.options)
    } else {
      api.reload('895970dc', component.options)
    }
    module.hot.accept("./projectList.vue?vue&type=template&id=895970dc&scoped=true", function () {
      api.rerender('895970dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/requirementAnalysis/comps/projectList.vue"
export default component.exports